import React from "react";
import CheckboxItem from "../../../components/print/workDiary/CheckboxItem";
import { Typography } from "antd";
import { useIntl } from "react-intl";
const { Text } = Typography;

const DailyPlanComments = (props) => {
  const intl = useIntl();
  return (
    <div className="section" style={{ width: "100%", padding: 0 }}>
      <div className="vertical_spacer" />
      <div className="rowContainer">
        <div className="horizontal_item_container" style={{ width: "50%" }}>
          <Text style={{ width: "fit-content" }}>
            {intl.formatMessage({
              id: "app.work_diary_print.comments",
            })}
          </Text>
          <div
            className="horizontal_line"
            style={{ display: "flex", flex: 1 }}
          />
        </div>

        <div className="horizontal_item_container" style={{ width: "17%" }}>
          <Text style={{ width: "fit-content" }}>
            {intl.formatMessage({
              id: "app.work_diary_print.hours_count",
            })}
          </Text>
          <div
            className="horizontal_line"
            style={{ display: "flex", flex: 1 }}
          />
        </div>

        <div className="horizontal_item_container" style={{ width: "13%" }}>
          <Text style={{ width: "fit-content" }}>
            {intl.formatMessage({
              id: "app.work_diary_print.driving",
            })}
          </Text>
          <div
            className="horizontal_line"
            style={{ display: "flex", flex: 1 }}
          />
        </div>

        <div className="horizontal_item_container" style={{ width: "20%" }}>
          <CheckboxItem name="free_monthly" auto={true} />
          <div
            className="horizontal_line"
            style={{ display: "flex", flex: 1, margin: 0 }}
          />
        </div>
      </div>

      <div className="vertical_spacer" />
    </div>
  );
};

export default DailyPlanComments;
